import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import './assets/css/element-variables.scss'
import vRegion from 'v-region'
import '@/assets/font/iconfont.css';
import * as util from './utils/index'
import './permission';
import '@/styles/index.scss'
import '@babel/polyfill'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(vRegion)

Object.defineProperty(Vue.prototype, '$util', {
    value: util,
    readable: true,
    writable: false
})

// 添加全局事件监控方法
Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'watchStorage') {

      // 创建一个StorageEvent事件
      var newStorageEvent = document.createEvent('StorageEvent');
      const storage = {
          setItem: function (k, val) {
              sessionStorage.setItem(k, val);

              // 初始化创建的事件
              newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

              // 派发对象
              window.dispatchEvent(newStorageEvent)
          }
      }
      return storage.setItem(key, newVal);
  }
}

Vue.prototype.$bus = new Vue()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
